/* eslint-disable */
import BASE from '../../../../vue.config.js'
const $ = require('jquery')
import 'prismjs'
import 'prismjs/themes/prism.css'


export default {
	

	data() {

		return {
			documentos: [],
			UpDocuments:[],
			selectedDoc:null,
			uploadPdfPopup: false,
		
			//Parte del estado del documento
			errorFileType: false,
  	 		isTemarioPreCharged: false,
			contieneDocumento :0,
			//donde se guarda el documento
			temario:{
				chargedDoc: {
				idDoc: 0,
				isCharged: false,
				name: '',
				file: null,
				eventTarget: null,
				fileLink: ''
				}
			},
	
			// estados del boton
			uploadFileCharged:{
				onProgress: false,
				readyProgess: false,
				fileError: null,
				text: 'cloud_upload',
				style:{
				height: null
				}
			}
		}
	},


	methods: {

		openUploadPdfPopup(doc){
			if (this.temario.isCharged) {
				this.deleteChargedFile(this.temario);
				this.temario.idDoc = doc;
			}
			
			this.uploadPdfPopup = true;
			this.selectedDoc = doc;
			this.temario.chargedDoc.idDoc= doc;
			
		},
        // upload file methods
		onDocChargeChanged(event){
			this.errorFileType = false;
			let fileType = event.target.files[0].type
			if (fileType == 'application/pdf') {
				this.selectedFile = event.target.files[0]
				//this.temario.idDoc = id;
				this.temario.chargedDoc.isCharged = true;
				this.temario.chargedDoc.name = this.selectedFile.name;
				this.temario.chargedDoc.file = this.selectedFile;
				this.temario.chargedDoc.eventTarget = event.target;
				this.temario.chargedDoc.uploadFile = this.uploadFileCharged;
				var read = new FileReader();
				read.onload = (e) => {
					this.temario.chargedDoc.filesrc = e.target.result;
					
				}
				read.readAsDataURL(this.temario.chargedDoc.file);
				this.contieneDocumento = 1;


				//Prueba para ver contenido de temario
				console.log(JSON.stringify(this.temario));
			}else{
 				this.errorFileMsg = 'Solo se permiten archivos con extensión .pdf'
				this.errorFileType = true;
			}
		},
		deleteChargedFile(documento){
			console.log(JSON.stringify(documento));
			console.log('*** deleteChargedFile ***');
			// Se borra el archivo cargado
			documento.chargedDoc.idDoc = 0;
			documento.chargedDoc.file = null;
			documento.chargedDoc.isCharged = false;
			documento.chargedDoc.name = '';
			documento.chargedDoc.filesrc = null,
			documento.uploadFile = this.uploadFileCharged;

			if (!this.isTemarioPreCharged) {
				// Como no se pueden borrar los objetos de un Filelist
				// se convierte el input a 'text' y se regresa a 'file'
				// de esta manera se borra el archivo que se cargó
				// el evento onDocChargeChanged ya hace efecto si se borra el archivo cargado
				// y se vuelve a subir el mismo archivo
				documento.chargedDoc.eventTarget.type = 'text';
				documento.chargedDoc.eventTarget.type = 'file';
			}
			this.isTemarioPreCharged = false;
			this.contieneDocumento = 0;
 		},
		 sendTemario(){
			if (this.temario.chargedDoc.file != null) {
				let vm = this;
				if (this.selectedDoc != null) {
					let objetoDocumento ={
						idAlumno: '',
						idDocumento: this.temario.chargedDoc.idDoc,
						TipoEvidencia: 1,
					}
					console.log(JSON.stringify(objetoDocumento))
					const formData = new FormData();
					formData.append('request', JSON.stringify(objetoDocumento));
					formData.append('archivos', this.temario.chargedDoc.file);
					console.log(JSON.stringify(this.temario.chargedDoc.file));
					
					$.ajax({
					   url: `${BASE.baseUrl}api/AgregarArchivo/`,
					   headers:{
						   'Authorization': sessionStorage.getItem('token')
					   },
					   type:'POST',
					   dataType:'json',
					   cache: false,
					   contentType: false,
					   processData: false,
					   data:formData,
					   success: function(rs){
						   console.log(rs)
						   if (rs.status === 200) {
							   vm.showNotify(rs.status, null, 'El documento se subio satisfactoriamente.');
							   vm.uploadPdfPopup = false; 
							   vm.deleteChargedFile(vm.temario);
							   vm.ObtenerListado();
							   
							}else{
							   vm.showNotify(rs.status);
							   vm.uploadPdfPopup = false;
							   vm.ObtenerListado();						 
							}
							
					   },
					   error: function (xhr, ajaxOptions, thrownError) {
						   console.log('error')
						   console.log(xhr.status);
						   console.log(thrownError);
					   }
				   });
				}
			
			}else{
				this.errorFileMsg = 'Debes cargar un documento para guardarlo'
				this.errorFileType = true;
			}
			
				
		
		},

		// END upload file methods
		ObtenerListado() {
			this.temario.chargedDoc.fileLink = BASE.baseUrl;
			fetch(`${BASE.baseUrl}api/ListadoDocumentos/`, {
				method: 'GET',
				headers: {
					'Authorization': sessionStorage.getItem('token'),
				}
			})
				.then(rs => rs.json())
				.then(rs => {
					if (rs.status == 200) {
						this.documentos=[];	
							
						rs.result.documentos.forEach((item, indx) => {
							this.documentos.push(item);
							
						});
						console.log('documentis'+ JSON.stringify(this.documentos));
					}
				});
		},
	},

	mounted() {
		this.ObtenerListado();
		
	},
}


